import React, { FC } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";

import Breadcrumbs from "../../shared/base-components/Breadcrumbs";
import CustomerList from "./CustomerList";

const CustomerPage: FC = () => {
  document.title =
    "Tüm müşteriler | Bu ekranda yapılacak işleri görüntülyebilirsiniz.";
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  return (
    <React.Fragment>
      <div className={isMobile ? "page-content-mobile" : "page-content"}>
        <Container fluid>
          <Breadcrumbs
            title="Tüm müşteriler"
            breadcrumbItem="Tüm müşteriler Listesi"
          />

          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <CustomerList />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CustomerPage;
